/**
 * 获取在指定范围内的随机数
 * @param min 最小值
 * @param max 最大值
 * @returns 返回满足条件的向下取整值
 */
export const getRandom = (min, max) => {
  return parseFloat(parseFloat(Math.random() * (max - min) + min).toFixed(6));
};

/**
 * 将链接字母转为单词分割
 * @param str 待转换的字符串
 * @returns 返回目标值 eg. "phoneNumber" | "phone_number" ===> "Phone Number"
 */
export const resverText = (str) => {
  return str.replace(/_/g, ' ').replace(/([A-Z])/g, ' $1').replace(/\b\w/g, (match) => ' ' + match.toUpperCase()).trim();
}

/**
 * 是否移动端设备
 * */
export const isMobile = () => {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true
  } else {
    return false
  }
}

/**
 * 判断一个字符串是否可以被序列化
 * @param str 字符串
 * @returns 返回是否能被序列
 */
export const isCanSerialize = (str: string) => {
  if (!str) return false
  if (typeof str !== 'string') {
    return false;
  }
  try {
    const parsed = JSON.parse(str);
    if (typeof parsed === 'object' && parsed !== null) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
}